import tableMixin from "./table-mixin"
import Header from "./header"

// 初始化时尽量不让内容换行导致表格每行高度过高
const BIG_COL_WIDTH = 10086

export default {
  name: "mm-thead",
  components: {
    "ui-table-header": Header,
  },
  mixins: [tableMixin],
  computed: {
    wrapperStyle() {
      const { scrollBarWidth, canScrollY } = this.store.layout
      return this.fixed ? {} : {
        marginRight: canScrollY ? 0 : `-${scrollBarWidth}px`,
        marginBottom: `-${scrollBarWidth}px`,
      }
    },
  },
  mounted() {
    !this.fixed && this.store.setRef("thead", this.$el)
  },
  render(h) {
    return (
      <div class="mm-thead" style={this.wrapperStyle} onScroll={this.scrollHandler}>
        <table style={this.tableStyle} cellpadding="0" cellspacing="0" border="0">
          <colgroup>
            {this.showSelectCol && <col width={this.store.layout.selectColWidth} />}
            {this.flattenColumns.map((column, index) => (
              <col key={index} width={column.width || BIG_COL_WIDTH} />
            ))}
          </colgroup>
          <ui-table-header
            columns={this.columns}
            fixed={this.fixed}
            store={this.store}
            rowSelection={this.rowSelection}
            showSelectColumn={this.showSelectCol}
          />
        </table>
      </div>
    )
  },
}
